export default "__VITE_ASSET__Cb8nzdg4__"